module.exports = __webpack_public_path__ + "static/media/seriousQuestion.f4cc67d6.mp3";